import { render, staticRenderFns } from "./BaseConfirmationModal.vue?vue&type=template&id=615bd28c&"
import script from "./BaseConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports